import { observable } from '@/libs/state'
import { domThemeAdapter } from './adapters/dom-theme'
import type { Theme } from './domain/theme'

const theme$ = observable<Theme>(domThemeAdapter.get())

export { theme$ }
export type { Theme }
